// extracted by mini-css-extract-plugin
export default {"announceBarWrap":"announcementBar-module--announceBarWrap--3cc5f","announceBarChild":"announcementBar-module--announceBarChild--dd2a9","close":"announcementBar-module--close--4afff"};